"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortBy = exports.chainCompare = void 0;
const chainCompare = (comparisonFns) => {
    for (const fn of comparisonFns) {
        const comparison = fn();
        if (comparison)
            return comparison;
    }
    return 0;
};
exports.chainCompare = chainCompare;
function sortBy(array, keyOrFn) {
    const genKey = typeof keyOrFn === "function"
        ? keyOrFn
        : (element) => element[keyOrFn];
    return [...array].sort((a, b) => {
        const keyA = genKey(a);
        const keyB = genKey(b);
        return keyA < keyB ? -1 : keyA > keyB ? 1 : 0;
    });
}
exports.sortBy = sortBy;
//# sourceMappingURL=sort.js.map